import { OptionalFeature } from '@news-mono/web-common'
import { createRenderTarget } from '../../render-target'
import { TheWestSection } from '../../__styling/settings/sections/thewest'
import { TheWestFooterNetworkLinksWeb } from './TheWestFooterNetworkLinks.web'

export interface Link {
    name: string
    link: string
    feature?: OptionalFeature
}

export interface NetworkLink {
    name: string
    links: Link[]
}

type RegionalSections = Exclude<TheWestSection, 'default'>

export interface BaseSocial {
    facebookMessenger: string
    facebook: string
    email: string
}

export interface Address {
    street: string
    city: string
    state: 'WA'
    postcode: number
    phone: string
}

// Regional Social links just have email, facebook & messenger, hence the BaseSocial type
// Regionals also include the Address interface
export type SectionSocialLinks = {
    [section in RegionalSections]: BaseSocial & Address
}

export type SectionedSocialLinks = SectionSocialLinks & {
    default: BaseSocial & {
        twitter: string
        instagram: string
        rss: string
        youtube?: string
    }
}

export interface TheWestFooterNetworkLinksProps {
    networkLinks: {
        regional: NetworkLink[]
        thewest: NetworkLink[]
    }
    socialLinks: SectionedSocialLinks
}

export const TheWestFooterNetworkLinks = createRenderTarget(
    'TheWestFooterNetworkLinks',
    {
        web: TheWestFooterNetworkLinksWeb,
        amp: TheWestFooterNetworkLinksWeb,
        rss: TheWestFooterNetworkLinksWeb,
        preview: TheWestFooterNetworkLinksWeb,
        app: null,
    },
)
TheWestFooterNetworkLinks.displayName = 'TheWestFooterNetworkLinks'
